export enum ListRendererActionType {
  dotMenu = 'dot_menu',
  bulkAction = 'bulk_action',
  onRowClick = 'on_row_click',
  onColumnClick = 'on_column_click',
  headerButton = 'header_button',
  drop = 'drop',
}
